import React, { useReducer } from "react";
import FileContext from "./FileContext";
import FileReducer from "./FileReducer";
import {
  GET_FILES,
  GET_FILES_LOADING,
  UPLOAD_FILES_ERROR,
  UPLOAD_FILES_LOADING,
  UPLOAD_FILES_RESULT
} from "../types";
import config from '../../config';
import { getHeaders } from "../../api/helpers";
import { axiosInstance } from "../../index";

const apiUrl = config.apiUrl + '/s3';

// Convert selected file to a base64 string
const toBase64 = file => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = error => reject(error);
});

const initialState = {
  getFilesLoading: false,
  uploadFilesLoading: false,
  uploadFilesResult: null,
  uploadFilesError: null,
  uploadedFiles: [],
};

const FileState = (props) => {
  const [state, dispatch] = useReducer(FileReducer, initialState);

  // Get uploaded files
  const getFiles = async (username) => {
    dispatch({
      type: GET_FILES_LOADING,
      payload: true
    });


    const result = await axiosInstance.get(
      apiUrl,
      { params: { username }, headers: getHeaders() },
    );

    console.log(result.data)

    dispatch({
      type: GET_FILES,
      payload: result.data.files
    });
  };

  const deleteFile = async (key) => {
    // Remove the fie from the uploadedFiles state
    dispatch({
      type: GET_FILES,
      payload: state.uploadedFiles.filter((element) => element.Key !== key)
    });

    return new Promise(async (resolve, reject) => {
      try {
        const result = await axiosInstance.delete(
          apiUrl,
          {
            headers: {
              filename: key.split('/')[1],
              ...getHeaders()
            }
          }
        );
        console.log(result.data);
        resolve(result.data);
      } catch (e) {
        reject(e)
      }
    })
  };

  const uploadFiles = async (files) => {
    // Each file error will be incremeneted to this variable
    let errorCount = 0;

    dispatch({
      type: UPLOAD_FILES_LOADING,
      payload: true
    });

    // Go through each object in the files array and initalize file upload
    const uploadedFilesArray = files.map(async (file) => {
      if (!file.file || !file.description) return;

      let { description } = file;
      const key = `${new Date().getTime()}.${description}.${file.file.name}`;

      // Encode the file value to a base 64 string
      const body = await toBase64(file.file);
      return new Promise((resolve) => {
        axiosInstance
          .post(
            apiUrl,
            body,
            {
              headers: {
                'Content-Type': 'text/plain',
                filename: key,
                username: 'kon', // TODO: Replace username placeholder
                ...getHeaders()
              }
            }
          ).then((result) => {
            resolve(result);
          }).catch((err) => {
            console.log(err)
            resolve(null)
            errorCount = errorCount + 1;
          });
      })
    });

    const result = await Promise.all(uploadedFilesArray);

    // If there's an error in one or more of the files, should the amount of errors
    if (errorCount > 0) {
      dispatch({
        type: UPLOAD_FILES_ERROR,
        payload: errorCount < files.length ?
          `Error uploading ${errorCount} file${errorCount > 1 ? 's' : ''}` : 'Files upload error'
      })
    };

    if (errorCount < files.length) {
      dispatch({
        type: UPLOAD_FILES_RESULT,
        payload: result.filter((resultItem) => resultItem !== null)
      });

      getFiles('kon');
    };
  };

  return (
    <FileContext.Provider
      value={{
        ...state,
        getFiles,
        deleteFile,
        uploadFiles
      }}
    >
      {props.children}
    </FileContext.Provider>
  );
};

export default FileState;
